import { render, staticRenderFns } from "./selectP.vue?vue&type=template&id=76ebdd68&"
import script from "./selectP.vue?vue&type=script&lang=js&"
export * from "./selectP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports